import React from 'react';
import { listLocales } from 'core/api';
import { AntSelect } from './ant/ant-select/antSelect';
import { AntSelectPropsGeneric } from './ant/ant-select/types';
import { observer } from 'mobx-react';
import { useRemoteListForSelect } from 'framework/api';

export type LocaleSelectorProps = AntSelectPropsGeneric<string>;

export const LocaleSelector = observer((props: LocaleSelectorProps) => {
	const remoteData = useRemoteListForSelect(listLocales(), {
		labelField: 'text',
		valueField: 'value',
	});

	return <AntSelect {...remoteData} {...props} />;
});
